import { EMPTY, MonoTypeOperatorFunction, Observable, OperatorFunction } from 'rxjs';
import { finalize, map } from 'rxjs/operators';
import { StartWithUnit } from './start-with-unit';

export function startWithLoading<T, V extends { loading: Record<StartWithUnit, boolean> }>(
    state: any,
    unit: StartWithUnit,
): MonoTypeOperatorFunction<T> {
    return (source: Observable<T>) => {
        if (state.get().loading?.[unit]) {
            return EMPTY;
        }

        state.set({ loading: { [unit]: true } } as V);

        return source.pipe(finalize(() => state.set({ loading: { [unit]: false } } as V)));
    };
}

export const getLoadingProp: (prop: StartWithUnit) => OperatorFunction<Record<StartWithUnit, boolean>, boolean> = (
    prop: StartWithUnit,
) => {
    return map((loading: Record<StartWithUnit, boolean>) => loading?.[prop]);
};
